
export default {
    namespaced: true,
	state: {
        alertMessage: null,
		isLoading: 0,
		title: '',
		backlink: false,
		fullHeight: false,
		revisionSurgery: null,
	},
	getters: {
		revisionSurgery: state => state.revisionSurgery
	},
	mutations: {
		setAlertMessage(state, alertMessage) {
			state.alertMessage = alertMessage
		},
		showLoader(state) {
			state.isLoading++
			//console.log('show', state.isLoading)
		},
		hideLoader(state, force = false) {
			state.isLoading = force ? 0 : Math.max(0, --state.isLoading)
			//console.log('hide', state.isLoading)
		},
		setTitle(state, title) {
			state.title = title
		},
        setBacklink(state, backlink) {
			state.backlink = backlink
        },
		setFullHeight(state, fullHeight) {
			state.fullHeight = fullHeight
		},
		setUpdateRevisionStatuses(state, item) {
			state.revisionSurgery = item
		},
	},
	actions: {
        alert({ commit }, message = null) {
			commit('setAlertMessage', message)
		},
		showLoader({ commit }) {
			commit('showLoader')
		},
		hideLoader({ commit }, force = false) {
			commit('hideLoader', force)
		},
		title({ commit }, title) {
			commit('setTitle', title)
			commit('setBacklink', null)
		},
        backlink({ commit }, backlink) {
			commit('setBacklink', backlink)
        },
		fullHeight({ commit }, fullHeight) {
			commit('setFullHeight', fullHeight)
		},
		updateRevisionStatuses({ commit }, surgery) {
			commit('setUpdateRevisionStatuses', surgery)
		},
    },
}
